import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { SetSession } from 'session-manager-beta';
import { ApiCall } from '../CommonComponents/CustomHooks';

const EventSelection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [Error, setError] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const ClientCode = queryParams.get('ClientCode');
    const Token = queryParams.get('Token');
    const [eventList, setEventList] = useState([]);
    SetSession('localStorage', 'ClientCode', ClientCode);
    SetSession('localStorage', 'Token', Token);
    const [clientLogo, setClientLogo] = useState('');
    const [clientBanner, setClientBanner] = useState('');

    const getEventList = async (e) => {
        setLoading(true)
        let data = await ApiCall('/api/EventProcess/GetEventData', { client: e, Token })
        setLoading(false)
        if (data.status === 'SUCCESS') {
            setError(false)
            setEventList(data)
        } else {
            setEventList([])
            setError(true)
        }
    }

    const GetEventNavigation = (i, value) => {
        navigate(`/DownloadProcess?EventCode=${i}&Token=${Token}`)
        SetSession('localStorage', 'buttonValue', value);
        SetSession('localStorage', 'EventCode', i);
    }
    const handleGetClientLogo = async (Type) => {
        try {
             setLoading(true)
            let data = await ApiCall(`/api/EventProcess/GetClientLogo`, { ClientCode,Token, Type });
             setLoading(false)
            if (data.status === 'SUCCESS') {
                setClientLogo(data.clientLogo);
                setClientBanner(data.clientBanner);
            } else if (data.status === 'ERROR') {
                console.log(data.message);
            }
        } catch (error) {
            console.error('Error GetClientLogo:', error);
        } finally {
             setLoading(false)
        }
    }
    useEffect(() => {
        document.title = 'Event Selection'
        handleGetClientLogo("ClientLogo");
        if (ClientCode) getEventList(ClientCode);
    }, [ClientCode]);

    if (loading) {
        return (
            <BlurLoader />
        )
    };

    return (
        <>
            <section className="header-outer-page sticky-top">
                <div className="container px-5">
                    <div className="row align-items-center">
                        <div className="col-8">
                            <div className="col-12">
                                <span
                                    style={{ display: "flex" }}
                                >
                                    <span id="imgClientLogo">
                                        {
                                            clientLogo && (
                                                <img
                                                    src={clientLogo ? clientLogo : ''}
                                                    alt=""
                                                    className="img-fluid"
                                                />
                                            )
                                        }
                                       
                                    </span>
                                    <div className="col-lg-10 col-md-10 col-sm-10">
                                        <span id="imgClientTopBanner">
                                            {
                                                clientBanner && (
                                                    <img
                                                        src={clientBanner ? clientBanner : ''}
                                                        alt=""
                                                        className="img-fluid"
                                                    />
                                                )
                                            }
                                           
                                        </span>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="tab-section">
                <style
                    dangerouslySetInnerHTML={{
                        __html:
                            "\n    #divMain{\n      background-image: url(./images/front-page-bg.jpg);\n    }\n"
                    }}
                />
                <section className="admin-challenge" id="divMain">
                    <div className="container px-5">
                        <div className="row justify-content-center">
                            <div className="col-lg-12">
                                <div className="challenge-options shadow">

                                    {Error || !ClientCode ?
                                        <div className='text-center ps-0'>
                                            <img src='./images/NoRecord.jpeg' height='400px' alt='Rail' />
                                        </div> :
                                        <>
                                            <p className='text-center fs-4 fw-bold text-dark m-1 mb-3'>
                                                Please Select Post
                                            </p>
                                            <div className="row justify-content-center">
                                                {eventList?.eventList?.map((item, index) =>
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="option mb-3 option-two" style={{ cursor: 'pointer' }}>
                                                            <div className="option-image" onClick={() => GetEventNavigation(item.eventCode, item.downloadButtonText)}>
                                                                <img
                                                                    className="img-fluid"
                                                                    data-imgeventcode={ClientCode}
                                                                    src=
                                                                    {
                                                                        item?.eventImage ? './' + item?.eventImage :
                                                                            './images/rail.jpg'
                                                                    }
                                                                    alt={item.eventName}
                                                                    onError={(e) => { e.target.style.display = 'none'; }}
                                                                />
                                                            </div>
                                                            <span onClick={() => GetEventNavigation(item.eventCode, item.downloadButtonText)}>
                                                                <button className="org-option fs-5" id="recruitment-tab">
                                                                    {item.eventName}
                                                                </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="mt-4">
                                                <div className="row">
                                                    <div
                                                        className="col-md-12 col-sm-12 col-xs-12 lblError"
                                                        style={{ borderRadius: 5 }}
                                                    >
                                                        <div 
                                                            style={{ height: 46, backgroundColor: "#1055ae" }}
                                                            className="lblError text-center pt-1 mt-4 fs-4 text-light"
                                                        >
                                                            {eventList.helpLineNo === "" ? "" : eventList.hText + " : " + eventList.helpLineNo}
                                                        </div>
                                                        <div
                                                            style={{ height: 46, backgroundColor: "#1055ae" }}
                                                            className="lblError text-center pt-1 mt-4 fs-4 text-light"
                                                        >
                                                             {eventList.helpDeskEmailID === "" ? "" : eventList.heText + " : " + eventList.helpDeskEmailID}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
            <section className="footer-outer">
                <div className="container">
                    <div className="row" />
                </div>
            </section>
        </>
    )
}
export default EventSelection;